export const topicCommunityTabs = {
  overview: 'overview',
  thread: 'thread',
  initiatives: 'initiatives',
  knowledgeHub: 'knowledgeHub',
  contactInfo: 'contactInfo',
} as const

export const topicCommunityTabsQueryParamName = 'tab'
